module.exports = __webpack_public_path__ + "static/img/next_hotel.3ab3ff4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/next_hotel.gif
// module id = TdGn
// module chunks = 0